import {
  STEP_2_FORM_FAILED,
  STEP_2_FORM_REQ,
  STEP_2_FORM_SUCCESS,
  STEP_3_FORM_FAILED,
  STEP_3_FORM_REQ,
  STEP_3_FORM_SUCCESS,
  TLAT_DETAILS_FORM_FAILED,
  TLAT_DETAILS_FORM_REQ,
  TLAT_DETAILS_FORM_SUCCESS,
} from "../Constant/FreeClassConctant";
import api from "../Core/api";

export const Form2Submit = (Contact_Id, DataRec) => async (dispatch) => {
  
  try {
    dispatch({ type: STEP_2_FORM_REQ });
    const { data } = await api.post(
      `/student/free/class/step2/${Contact_Id}`,
      DataRec,
    );
   
    dispatch({
      type: STEP_2_FORM_SUCCESS,
      payload: data?.Result,
      URL: data?.URL,
    });
  } catch (error) {
   
    dispatch({
      type: STEP_2_FORM_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const Form3Submit = (Contact_Id, DataRec) => async (dispatch) => {
 
  try {
    dispatch({ type: STEP_3_FORM_REQ });
    const { data } = await api.put(
      `/student/free/class/step3/${Contact_Id}`,
      DataRec,
    );
    dispatch({ type: STEP_3_FORM_SUCCESS, payload: data?.Result });
  } catch (error) {
   
    dispatch({
      type: STEP_3_FORM_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const DetailsTest = (Id) => async (dispatch) => {
  try {
    dispatch({ type: TLAT_DETAILS_FORM_REQ });
    const { data } = await api.get(`/student/free/class/TestDet/${Id}`);
    dispatch({ type: TLAT_DETAILS_FORM_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: TLAT_DETAILS_FORM_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
